import { Reveal } from "./Reveal";
import { StarDivider } from "./Star";

const chapters = [
  {
    num: "01",
    title: "We Gather",
    body: "From Friday dinners to Eid festivals, we create the rooms where Jordanians across Australia meet, laugh and belong. Every gathering is an open door — individuals, families, newcomers and old friends.",
  },
  {
    num: "02",
    title: "We Celebrate",
    body: "Dabke footsteps, oud strings, the smell of mansaf and cardamom coffee. We keep Jordanian culture alive on Australian soil — teaching our children the songs, stories and flavours of home.",
  },
  {
    num: "03",
    title: "We Give",
    body: "Almadafah means generosity. Through charitable initiatives and social support, we stand beside families doing it tough — here in Australia and back home in Jordan.",
  },
  {
    num: "04",
    title: "We Connect",
    body: "Mentors meet students, businesses meet customers, newcomers meet their first friends. Our network turns a diaspora into a community — and a community into a family.",
  },
];

export default function Manifesto() {
  return (
    <section id="about" data-testid="manifesto-section" className="mx-auto max-w-[1600px] px-5 py-24 sm:px-10 sm:py-36">
      <Reveal>
        <p className="mb-4 font-display text-xs font-bold uppercase tracking-[0.3em] text-jordan-red" data-testid="manifesto-overline">
          The Manifesto · من نحن
        </p>
        <h2 className="max-w-4xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-6xl">
          One house. <span className="font-serifx font-medium normal-case italic text-jordan-green">Four promises.</span>
        </h2>
      </Reveal>

      <div className="mt-16 sm:mt-24">
        {chapters.map((c, i) => (
          <Reveal key={c.num} delay={0.05}>
            <article
              data-testid={`manifesto-chapter-${c.num}`}
              className="group grid grid-cols-1 gap-6 border-t border-jordan-ink/15 py-12 transition-colors duration-500 last:border-b hover:bg-jordan-sanddeep/60 sm:grid-cols-12 sm:py-16"
            >
              <div className="sm:col-span-4 lg:col-span-3">
                <span className="font-serifx text-[6rem] leading-none text-jordan-red/25 transition-colors duration-500 group-hover:text-jordan-red sm:text-[9rem] lg:text-[11rem]">
                  {c.num}
                </span>
              </div>
              <div className="sm:col-span-8 lg:col-span-6 lg:col-start-6">
                <h3 className="mb-5 font-display text-3xl font-black uppercase tracking-tight sm:text-5xl">
                  {c.title}
                </h3>
                <p className="max-w-xl text-base leading-relaxed text-jordan-mute sm:text-lg">{c.body}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-20">
        <StarDivider />
        <p className="mx-auto mt-10 max-w-3xl text-center font-serifx text-2xl italic leading-snug text-jordan-ink sm:text-3xl" data-testid="manifesto-quote">
          “We create opportunities for individuals and families to connect, participate in
          community initiatives, attend events and support meaningful causes.”
        </p>
      </Reveal>
    </section>
  );
}
